import { render, staticRenderFns } from "./TheSystemMessages.vue?vue&type=template&id=45091da3"
import script from "./TheSystemMessages.vue?vue&type=script&lang=js"
export * from "./TheSystemMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports